import React from "react";
import PropTypes from "prop-types";
import { Icon, useBreakpoints } from "@qgiv/core-react";
import "./ReceiptHeader.scss";
import ConnectedEventDateAndLocation from "./AccountCTA/ConnectedEventDateAndLocation";
import ConnectedReceiptQrCodeGuestManagementCallout from "./ConnectedReceiptQrCodeGuestManagementCallout";

const ReceiptHeading = ({
    heading,
    renderHeading = (_heading) => <h1>{_heading}</h1>,
}) => <>{renderHeading(heading)}</>;

ReceiptHeading.propTypes = {
    heading: PropTypes.string.isRequired,
    renderHeading: PropTypes.func,
};

const ReceiptHeader = ({
    transactionId,
    renderHeading = (heading) => <h1>{heading}</h1>,
    heading,
    receiptId,
    controlId,
}) => {
    const { isMediumScreen } = useBreakpoints();
    return (
        <div className="receipt-header grid">
            <div className="col col--12 -text--center">
                <Icon
                    className="receipt-header__confirmation-icon -color--theme-primary"
                    glyph="qgiv-confirmation"
                    type="Custom"
                />
            </div>
            <div className="col col--12 -text--center">
                <div className="grid">
                    <div className="col">
                        <p>
                            <span className="-color--theme-primary">
                                <Icon
                                    type="FontAwesome"
                                    glyph="receipt-regular"
                                />{" "}
                                <strong>Transaction #{transactionId}</strong>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="col col--12 -text--center">
                <ReceiptHeading
                    heading={heading}
                    renderHeading={renderHeading}
                />
                <div className="-padding-top--10">
                    <ConnectedEventDateAndLocation controlId={controlId} />
                </div>
                <ConnectedReceiptQrCodeGuestManagementCallout
                    receiptId={receiptId}
                    controlId={controlId}
                    isMediumScreen={isMediumScreen}
                />
            </div>
        </div>
    );
};

ReceiptHeader.propTypes = {
    transactionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    heading: PropTypes.string.isRequired,
    renderHeading: PropTypes.func,
    receiptId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    controlId: PropTypes.number.isRequired,
};

export default ReceiptHeader;
